"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTagInput = _interopRequireDefault(require("@pathofdev/react-tag-input"));

require("@pathofdev/react-tag-input/build/index.css");

var _excluded = ["value", "onChange", "label", "testId", "testIdIndex"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TagsList = function TagsList(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      label = _ref.label,
      testId = _ref.testId,
      testIdIndex = _ref.testIdIndex,
      restProps = _objectWithoutProperties(_ref, _excluded);

  (0, _react.useEffect)(function () {
    if (testId !== undefined) {
      document.getElementsByClassName('react-tag-input__input')[0].setAttribute('data-testid', testId);
      var content = document.getElementsByClassName('react-tag-input__tag__content');
      var remove = document.getElementsByClassName('react-tag-input__tag__remove');

      if (content.length > 0) {
        for (var index = 0; index < content.length; index++) {
          var c1 = content[index];
          var r1 = remove[index];
          c1.setAttribute('data-testid', "tag-".concat(index, "-value"));
          r1.setAttribute('data-testid', "tag-".concat(index, "-remove"));
        }
      }
    }
  }, [onChange, testId, testIdIndex]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group",
    "data-testid": "".concat(label.toLowerCase().replaceAll(' ', '-'), "-section")
  }, label && /*#__PURE__*/_react["default"].createElement("label", {
    className: "mb-1"
  }, label), /*#__PURE__*/_react["default"].createElement(_reactTagInput["default"], _extends({
    tags: value,
    onChange: onChange
  }, restProps)));
};

var _default = TagsList;
exports["default"] = _default;